import { get, post } from 'utils/rxfetch'

const URL = '/members-api/plg/discovery-banner'

const plgDiscoveryBannerAPI = {
  getState() {
    return get(URL)
  },
  markFirstInvestigationCompleted() {
    return post(URL, {})
  },
  // Per-session X-button dismissal. Banner reappears next login (PLG Experience §1.1).
  dismissSession() {
    return post(`${URL}/dismiss-session`, {})
  },
}

export default plgDiscoveryBannerAPI
